import { Component, EventEmitter, OnInit, Input, Output, ElementRef, forwardRef } from '@angular/core';
import { Router } from '@angular/router';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { TrailService, UtilsService } from 'core/services';
@Component({
  selector: 'lms-button-actions',
  templateUrl: './button-actions.component.html',
  styleUrls: ['./button-actions.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ButtonActionsComponent),
      multi: true
    }
  ]
})
export class ButtonActionsComponent implements OnInit {
  @Output() change = new EventEmitter<Object>();
  @Input() items?: Array<any>;
  @Input() selectedItem?: any = null;
  @Input() dropdownVisible?: boolean = false;
  @Input() iconSize?: string = 'normal';
  public buttonId: string = UtilsService.createGuid();

  constructor(public router: Router, public elementRef: ElementRef, private trailService: TrailService) {}

  public ngOnInit() {
    const id = this.elementRef.nativeElement.id;
    if (id) {
      const trail = this.trailService.getTrailFor(id);
      this.dropdownVisible = trail.dropdownVisible;
    }
  }

  public selectItem(item) {
    this.selectedItem = item.key;
    this.change.emit(item.key);
  }

  get selected() {
    return this.selectedItem ? this.items.find((item) => item.key === this.selectedItem).value : '';
  }

  public toggleMenu(event) {
    this.dropdownVisible = event.detail.open;
  }
}
